<app-spinner></app-spinner>
<div class="container">
  <div class="row">
    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="padding: 10px">
      <mat-card class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
        <mat-card-header>
          <div style="margin-top: 1%"></div>
          <mat-card-title>
            <div class="backcontainer">
              <div class="Back" [routerLink]="['/responseMapping']">
                <img src="assets/img/icons/shape-1.png" /> <span> Back</span>
              </div>
            </div>
            <div class="headLabel">Response Mapping</div>
          </mat-card-title>
        </mat-card-header>
        <div class="row">
          <div class="col-sm-12 col-xs-12 col-md-8 col-lg-8">
            <mat-card
              style="margin-top: 10px"
              class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
            >
              <mat-card-header> <h4>Add</h4> </mat-card-header>

              <!-- <table border='1' cellpadding='5'>
  <tr *ngFor="let item of entity | orderBy:'name'">
    <td>{{item.name}}</td>
  </tr>
</table> -->

              <form [formGroup]="apiResponseMapping" class="example-form mt-2">
                <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                  <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">
                    Entity *
                  </div>
                  <div class="col-sm-12 col-xs-12 col-md-1 col-lg-1 flabel">
                    :
                  </div>
                  <div class="col-sm-12 col-xs-12 col-md-8 col-lg-8">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Entity </mat-label>
                      <mat-select
                        disableRipple
                        (selectionChange)="Entitychange($event.value)"
                        formControlName="Entity"
                      >
                        <mat-option
                          *ngFor="let entity of entity | orderBy : 'name'"
                          [value]="entity.entityId"
                        >
                          {{ entity.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                  <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">
                    Name *
                  </div>
                  <div class="col-sm-12 col-xs-12 col-md-1 col-lg-1 flabel">
                    :
                  </div>
                  <div class="col-sm-12 col-xs-12 col-md-8 col-lg-8">
                    <mat-form-field
                      appearance="outline"
                      class="example-full-width"
                      style="width: 100%"
                    >
                      <mat-label>Name </mat-label>
                      <input
                        (keypress)="handleInput($event)"
                        matInput
                        formControlName="Name"
                        value=""
                      />
                    </mat-form-field>
                    <!--  <mat-error *ngIf="!apiResponseMapping.value.Name">Name is Required</mat-error> -->
                  </div>
                </div>

                <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                  <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">
                    Base Value Loop *
                  </div>
                  <div class="col-sm-12 col-xs-12 col-md-1 col-lg-1 flabel">
                    :
                  </div>
                  <div class="col-sm-12 col-xs-12 col-md-8 col-lg-8">
                    <mat-form-field
                      appearance="outline"
                      class="example-full-width"
                      style="width: 100%"
                    >
                      <mat-label>Base Value</mat-label
                      ><!--  <input matInput formControlName="BaseValueLoop" value=""> </mat-form-field> -->

                      <mat-select formControlName="BaseValue">
                        <mat-option
                          *ngFor="let dattr of apiDynamicAttribue"
                          [value]="dattr"
                        >
                          {{ dattr }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                  <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">
                    Info Highlights/Highlighted
                  </div>
                  <div class="col-sm-12 col-xs-12 col-md-1 col-lg-1 flabel">
                    :
                  </div>
                  <div class="col-sm-12 col-xs-12 col-md-8 col-lg-8">
                    <mat-form-field
                      appearance="outline"
                      class="example-full-width"
                      style="width: 100%"
                    >
                      <mat-label>Info Highlighted</mat-label>
                      <input
                        matInput
                        formControlName="infoHighlight"
                        value="{{ info }}"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <!--Dynamic Parameter Begin  -->
                <mat-card
                  class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
                  formArrayName="Mapping"
                >
                  <mat-label
                    >Mapping
                    <img
                      style="padding-left: 10px; height: 25px; width: 35px"
                      src="assets/img/icons/group-31.png "
                      (click)="addParameter()"
                  /></mat-label>
                  <!-- loop throught units-->
                  <div
                    class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
                    *ngFor="
                      let parameter of apiResponseMapping.get('Mapping')[
                        'controls'
                      ];
                      let i = index
                    "
                  >
                    <!-- row divider show for every nex row exclude if first row -->
                    <!-- <mat-divider
							*ngIf="apiResponseMapping.controls.parameter.controls.length > 1 && i > 0">
						</mat-divider> -->
                    <br />

                    <!-- group name in this case row index -->

                    <div [formGroupName]="i">
                      <div
                        fxLayout="row"
                        fxLayout.xs="column"
                        fxLayoutWrap
                        fxLayoutGap="3.5%"
                        fxLayoutAlign="center"
                      >
                        <mat-form-field
                          appearance="outline"
                          style="width: 30%; padding-right: 10px"
                        >
                          <mat-label>Key</mat-label>
                          <mat-select
                            (selectionChange)="attributeChange($event.value)"
                            formControlName="Attribute"
                          >
                            <!-- <mat-option
                        *ngFor="let attr of Attribute | orderBy : 'name'"
                        [value]="attr.attributeId"
                      > -->
                            <mat-option
                              *ngFor="let attr of Attribute | orderBy : 'name'"
                              [value]="attr"
                            >
                              {{ attr.name }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <mat-form-field
                          appearance="outline"
                          style="width: 30%; padding-right: 10px"
                        >
                          <mat-label></mat-label>
                          <mat-label>parameterType</mat-label>
                          <mat-select formControlName="parameterType">
                            <mat-option value="1">Hardcoded</mat-option>
                            <mat-option value="2">Mapped</mat-option>
                            <mat-option value="3">Formula</mat-option>
                          </mat-select>
                        </mat-form-field>

                        <mat-form-field
                          *ngIf="
                            this.apiResponseMapping.value.Mapping[i]
                              .parameterType == 1
                          "
                          appearance="outline"
                          style="width: 30%"
                        >
                          <mat-label>Value</mat-label>
                          <input
                            matInput
                            placeholder="value"
                            type="text"
                            formControlName="AttributeMap"
                          />
                        </mat-form-field>

                        <mat-form-field
                          *ngIf="
                            this.apiResponseMapping.value.Mapping[i]
                              .parameterType == 3
                          "
                          appearance="outline"
                          style="width: 30%"
                        >
                          <mat-label>Value</mat-label>
                          <textarea
                            matInput
                            placeholder="value"
                            formControlName="AttributeMap"
                          ></textarea>
                        </mat-form-field>

                        <mat-form-field
                          *ngIf="
                            !this.apiResponseMapping.value.Mapping[i]
                              .parameterType
                          "
                          appearance="outline"
                          style="width: 30%"
                        >
                          <mat-label>Value</mat-label>
                          <input
                            matInput
                            placeholder="value"
                            type="text"
                            formControlName="AttributeMap"
                          />
                        </mat-form-field>

                        <mat-form-field
                          *ngIf="
                            this.apiResponseMapping.value.Mapping[i]
                              .parameterType == 2
                          "
                          appearance="outline"
                          style="width: 30%; padding-right: 10px"
                        >
                          <mat-label></mat-label> <mat-label>Value</mat-label>

                          <mat-select formControlName="AttributeMap">
                            <mat-option
                              *ngFor="let dattr of apiDynamicAttribue"
                              [value]="dattr"
                            >
                              {{ dattr }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <!-- <mat-checkbox [checked]="this.apiResponseMapping.controls['parameter'].value[i].isPositional === true"  formControlName="isPositional" checked="{{this.apiResponseMapping.controls['parameter'].value[i].isPositional}}"  (change)="onChange($event, i, apiResponseMapping.controls.parameter.controls)"   style="width:10%;padding-right: 10px;padding-left: 10px">
										</mat-checkbox> -->

                        <img
                          style="padding-left: 6px; padding-bottom: 10px"
                          (click)="removeParameter(i)"
                          src="assets/img/icons/forma-1.png"
                        />
                      </div>
                    </div>
                  </div>
                </mat-card>
                <!--Dynamic Parameter End  -->

                <div class="col-sm-6 col-xs-6 col-md-6 col-lg-6">
                  <div class="col-sm-6 col-xs-6 col-md-6 col-lg-6"></div>
                  <button
                    [disabled]="!apiResponseMapping.valid"
                    class="col-sm-6 col-xs-6 col-md-6 col-lg-6"
                    mat-flat-button
                    style="width: 100%"
                    mat-flat-button
                    class="btn"
                    (click)="addResponseMapping()"
                  >
                    Save
                  </button>
                </div>
              </form>
            </mat-card>
          </div>

          <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
            <mat-card
              style="margin-top: 10px; min-height: 80vh"
              class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
            >
              <div class="loader"></div>
              <!-- Spinner End -->
              <div *ngIf="apiResponseData">
                <pre style="height: 80vh">			{{ apiResponseData | json }}</pre>
              </div>
            </mat-card>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
